import { ApiError, t } from '@identity/shared';

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError || error instanceof Error) return error.message;
  return t('Something went wrong.');
}

/** Messages of a validation error, keyed by field name. */
export function fieldErrors(error: unknown): Record<string, string> {
  return error instanceof ApiError ? error.fieldErrors : {};
}
